module.exports = require("@swa-ui/core/src/Text/Text.module.scss");